<template>
  <div class="w-full">
    <div class="flex flex-col lg:flex-row w-full mb-4 space-y-3 lg:space-y-0 lg:space-x-4">
      <div class="w-fit h-fit flex space-x-3 place-self-center"
        ref="topList"
      >
        <Squares2X2Icon class="w-6 h-6 hover:cursor-pointer" :class="gridClasses" @click="viewGrid()" />
        <ListBulletIcon class="w-6 h-6 hover:cursor-pointer" :class="listClasses" @click="viewList()" />
        <Bars4Icon class="hidden lg:block w-6 h-6 hover:cursor-pointer" :class="tableClasses" @click="viewTable()" />
      </div>
      <!-- <ais-state-results>
        <template v-slot="{ state }">
          <base-button
            borders="slim"
            padding="squared"
            elements-color="fill-gray-400 border-gray-300
                hover:fill-lh_red hover:border-lh_red
                dark:text-gray-100 dark:hover:text-slate-800"
            @click="handleExport(state)"
          >
            <template v-slot:icon>

            </template>
          </base-button>
        </template>
      </ais-state-results> -->
      <div class="w-full lg:hidden">
        <mobile-filters />
      </div>
      <ais-search-box
        :placeholder="$t('frontoffice.products.searchProduct')"
        :class-names="{
          'ais-SearchBox': 'flex flex-grow',
          'ais-SearchBox-form': 'rounded-lg',
        }"
      />

    </div>
    <custom-pagination
      color="lh_red"
    />
    <ais-configure filters="availableForOrders:true" />
    <ais-hits
      :class-names="{
        'ais-Hits-list': `hits-list ${marginLayout}` ,
        'ais-Hits-item': `bg-transparent shadow-none p-0 overflow-hidden items-start ${itemBorder}`,
      }"
    >
      <template v-slot="{ items }">
        <p v-if="items.length === 0" class="text-xl italic p-2 text-center">{{ $t('apiErrors.notFound') }}</p>
      </template>
      <template v-slot:item="{ item }">
        <card-product-horizontal
          v-if="listLayout"
          :product="item"
        />
        <card-product-vertical
          v-if="gridLayout"
          :product="item"
        >
        </card-product-vertical>
        <product-table-layout
          v-if="tableLayout"
          :product="item"
        >
        </product-table-layout>
      </template>
    </ais-hits>
    <custom-pagination
      color="lh_red"
      @click.prevent="scrollToTop()"
    />
  </div>
</template>

<script>
// import { useToast } from 'vue-toastification';
import { mapActions, mapGetters } from 'vuex';
import getSearchClient from '@/utils/search-services';
import { AisSearchBox, AisConfigure } from 'vue-instantsearch/vue3/es';
import 'instantsearch.css/themes/satellite.css';
import CardProductHorizontal from '@/components/products/CardProductHorizontal.vue';
import CardProductVertical from '@/components/products/CardProductVertical.vue';
import ProductTableLayout from '@/components/products/ProductTableLayout.vue';
import MobileFilters from '@/components/base/MobileFilters.vue';
import CustomPagination from '@/components/base/CustomPagination.vue';
import { Bars4Icon, Squares2X2Icon, ListBulletIcon } from '@heroicons/vue/24/outline';

export default {
  components: {
    AisSearchBox,
    AisConfigure,
    // AisStateResults,
    CardProductHorizontal,
    CardProductVertical,
    ProductTableLayout,
    MobileFilters,
    CustomPagination,
    Bars4Icon,
    Squares2X2Icon,
    ListBulletIcon,
  },
  // setup() {
  //   const toast = useToast();

  //   return { toast };
  // },
  data() {
    return {
      footerDirection: 'horizontal',
      searchClient: getSearchClient(),
      listLayout: false,
      gridLayout: true,
      tableLayout: false,
      activeButton: null,
    };
  },
  props: {
    periodFilter: {
      type: Object,
    },
  },
  async created() {
    this.mobileView();
    await this.getVats();
    //    if (this.$route.query.filter === 'campaignId') {
    //      this.getCampaign(this.$route.query.value);
    //    }
  },
  computed: {
    ...mapGetters('customers', ['customer']),
    //    ...mapGetters('campaigns', ['campaign']),
    gridClasses() {
      return this.gridLayout === true
        ? 'text-lh_gold scale-125 duration-300' : 'text-gray-300 hover:text-lh_gold';
    },
    listClasses() {
      return this.listLayout === true
        ? 'text-lh_gold scale-125 duration-300' : 'text-gray-300 hover:text-lh_gold';
    },
    tableClasses() {
      return this.tableLayout === true
        ? 'text-lh_gold scale-125 duration-300' : 'text-gray-300 hover:text-lh_gold';
    },
    marginLayout() {
      if (this.gridLayout) {
        return 'grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4';
      }
      if (this.listLayout) {
        return 'flex flex-col';
      }
      return 'flex flex-col';
    },
    itemBorder() {
      if (this.tableLayout) {
        return 'border-b last:border-b';
      }
      return 'rounded-lg first-of-type:rounded-lg last-of-type:rounded-lg';
    },
  },
  methods: {
    ...mapActions('vats', ['getVats']),
    // ...mapActions('campaigns', ['getCampaign']),
    mobileView() {
      if (window.innerWidth < 1024) {
        this.listLayout = false;
        this.gridLayout = true;
        this.tableLayout = false;
      }
    },
    viewGrid() {
      this.gridLayout = true;
      this.listLayout = false;
      this.tableLayout = false;
    },
    viewList() {
      this.listLayout = true;
      this.gridLayout = false;
      this.tableLayout = false;
    },
    viewTable() {
      this.tableLayout = true;
      this.listLayout = false;
      this.gridLayout = false;
    },
    scrollToTop() {
      this.$refs.topList.scrollIntoView({ behavior: 'smooth' });
    },
    // handleExport(state) {
    //   const url = this.buildExportUrl(state);

    //   this.toast.info(
    //     'Non chiudere la nuova scheda fino al completamento del download',
    //     {
    //       timeout: 2000,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //     },
    //   );

    //   setTimeout(() => {
    //     const popup = window.open(url, '_blank');

    //     if (popup) {
    //       this.toast.success('Download avviato con successo', {
    //         timeout: 6000,
    //       });
    //     } else {
    //       this.toast.error('Non siamo riusciti ad aprire la nuova scheda. Controlla il blocco pop-up.');
    //     }
    //   }, 3000);
    // },
    // buildExportUrl(state) {
    //   const params = new URLSearchParams();

    //   const filterMap = {
    //     productCategorySlug: 'categorySlug',
    //     productSubcategorySlug: 'subcategorySlug',
    //     isEssential: 'isEssential',
    //     outOfStock: 'outOfStock',
    //   };
    //   if (this.$route.query.latest) {
    //     params.append('availableFrom', `${this.lastFriday}:${this.nextThursday}`);
    //   } else if (this.$route.query.upcoming) {
    //     params.append('availableFrom', `${this.tomorrow}:${Math.floor(Date.now() / 1000) + 3600 * 24 * 365}`);
    //   } else {
    //     const dateRange = state.numericRefinements?.availableFromUnix;
    //     if (dateRange?.['>='] && dateRange?.['<=']) {
    //       params.append('availableFrom', `${dateRange['>='][0]}:${dateRange['<='][0]}`);
    //     }
    //   }
    //   if (this.$route.query.filter === 'campaignId') {
    //     params.append('campaigns', this.campaign.title);
    //   }
    //   if (this.$route.query.category) {
    //     params.append('categorySlug', this.$route.query.category);
    //   }
    //   if (this.$route.query.filter && this.$route.query.value) {
    //     const exportFilter = filterMap[this.$route.query.filter];
    //     if (exportFilter) {
    //       params.append(exportFilter, this.$route.query.value);
    //     }
    //   }

    //   const refinements = state.disjunctiveFacetsRefinements || {};
    //   if (state.query) {
    //     params.append('query', state.query);
    //   }
    //   if (refinements.ETICHETTA?.length) {
    //     params.append('labels', refinements.ETICHETTA.join('~'));
    //   }
    //   if (refinements.AUTORE?.length) {
    //     params.append('authors', refinements.AUTORE.join('~'));
    //   }
    //   if (refinements.SUPPORTO?.length) {
    //     params.append('formats', refinements.SUPPORTO.join('~'));
    //   }
    //   if (refinements.productBrandName?.length) {
    //     params.append('brands', refinements.productBrandName.join('~'));
    //   }
    //   if (refinements.productSubcategoryName?.length) {
    //     params.append('subcategories', refinements.productSubcategoryName.join('~'));
    //   }
    //   if (this.$route.query.onlyInStock) {
    //     params.set('outOfStock', 'false');
    //   }

    //   return `/download-excel?${params.toString()}`;
    // },
  },
};
</script>

<style>
.hits-list {
  @apply justify-between
}
</style>
